import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/ClaimApi";

export class ClaimService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getClaims", args);
  }
  async getPanel(id) {
    return await this.transformer.getGridPanel(this.Api, "getClaim", null, id);
  }
  async get(id) {
    return await this.transformer.getItem(this.Api, "getClaim", id);
  }
  async checkClaimCache(hashCode) {
    return await this.transformer.getGrid(this.Api, "checkClaimCache", hashCode);
  }
}
